<template>
    <modal-template>
        <div slot="header">
            {{ trans('reporting.export.excel.title') }}
        </div>

        <div slot="body">
            <section class="form-section">
                <div class="form-row">
                    <div class="form-row__col">
                        <alert type="info">
                            {{ trans('reporting.export.excel.info') }}
                        </alert>
                    </div>
                </div>
            </section>
            <section class="form-section">
                <div class="form-section-heading">
                    {{ trans('reporting.export.excel.client.heading') }}
                </div>
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <div class="radiobutton">
                            <label for="configClientEach">
                                <input
                                    type="radio"
                                    name="configClient"
                                    v-model="configClient"
                                    value="each"
                                    id="configClientEach"
                                />
                                <div class="radiobutton__fake-box">
                                    <img src="/images/icons/success.svg" alt="Success checkmark">
                                </div>
                                {{ trans('reporting.export.excel.client.each') }}
                            </label>
                        </div>
                    </div>
                    <div class="form-row__col form-row__col--one-half">
                        <div class="radiobutton">
                            <label for="configClientCombined">
                                <input
                                    type="radio"
                                    name="configClient"
                                    v-model="configClient"
                                    value="combined"
                                    id="configClientCombined"
                                />
                                <div class="radiobutton__fake-box">
                                    <img src="/images/icons/success.svg" alt="Success checkmark">
                                </div>
                                {{ trans('reporting.export.excel.client.combined') }}
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <section class="form-section">
                <div class="form-section-heading">
                    {{ trans('reporting.export.excel.course.heading') }}
                </div>
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <div class="radiobutton">
                            <label for="configCourseEach">
                                <input
                                    type="radio"
                                    name="configCourse"
                                    v-model="configCourse"
                                    value="each"
                                    id="configCourseEach"
                                />
                                <div class="radiobutton__fake-box">
                                    <img src="/images/icons/success.svg" alt="Success checkmark">
                                </div>
                                {{ trans('reporting.export.excel.course.each') }}
                            </label>
                        </div>
                    </div>
                    <div class="form-row__col form-row__col--one-half">
                        <div class="radiobutton">
                            <label for="configCourseCombined">
                                <input
                                    type="radio"
                                    name="configCourse"
                                    v-model="configCourse"
                                    value="combined"
                                    id="configCourseCombined"
                                />
                                <div class="radiobutton__fake-box">
                                    <img src="/images/icons/success.svg" alt="Success checkmark">
                                </div>
                                {{ trans('reporting.export.excel.course.combined') }}
                            </label>
                        </div>
                    </div>
                </div>
            </section>
        </div>


        <div slot="footer">
            <div class="page-control h:margin-top-4">
                <div class="page-control__element">
                    <button type="button" @click="$emit('close')" class="btn btn--big btn--secondary h:margin-right-4">{{ trans('buttons.cancel') }}</button>
                    <button type="button" @click="submit" class="btn btn--big btn--primary">{{ trans('buttons.ok') }}</button>
                </div>
            </div>
        </div>
    </modal-template>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: {
        dataObject: {
            type: Object,
            required: true,
            default: () => { return {}; }
        }
    },

    data() {
        return {
            configClient: 'each',
            configCourse: 'combined',
        }
    },

    methods: {
        /**
         * When submit, send the seleted learning contents data back to FormFields.
         */
        submit() {
            this.dataObject.config = {'client': this.configClient, 'course': this.configCourse};
            console.log(this.dataObject);
            EventBus.$emit('excelExportConfigSet', this.dataObject);
            this.$emit('close');
        },
    },
}
</script>
